/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendationClassificationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyRecommendationClassificationQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyRecommendationClassificationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendationClassificationQueryOperator>): PolicyRecommendationClassificationQueryOperator {
        let obj = Object.assign(new PolicyRecommendationClassificationQueryOperator(), model);
        PolicyRecommendationClassificationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendationClassificationQueryOperator>): PolicyRecommendationClassificationQueryOperator {
        if (!model) return null;
        return PolicyRecommendationClassificationQueryOperator.newInstance(<PolicyRecommendationClassificationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendationClassificationQueryOperator) {
        if (!obj) return;

        models.PolicyRecommendationClassificationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendationClassificationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyRecommendationClassificationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Classifications to include. Please note that if this is defined, only policy-related recommendations will be fetched.
     */
    classifications: Array<models.PolicyClassification>;

}
